// @vue/component
export default {
  name: 'AddressBookAddNewNumberForm',

  props: {
    projectList: {
      type: Array,
      default: () => [],
    },
    initialNumber: {
      type: String,
      default: '',
    }
  },

  data() {
    return {
      addressBookNewItemForm: {
        num_a: '',
        project: '',
        description: '',
        vip: false,
      },
      rules: {
        num_a: [
          { required: true, message: 'Pole jest wymanage', trigger: 'blur' },
        ],
        project: [
          { required: true, message: 'Pole jest wymanage', trigger: 'blur' },
        ],
        description: [
          { required: true, message: 'Pole jest wymanage', trigger: 'blur' },
        ],
      },
    };
  },

  mounted() {
    if (this.projectList && this.projectList.length === 1) {
      this.addressBookNewItemForm.project = this.projectList[0].uuid;
    }
    if (!!this.initialNumber) {
      this.addressBookNewItemForm.num_a = parseInt(this.initialNumber);
    }
  },
  computed: {
    isLoading() {
      return this.$store.getters['global/pendingAsyncStoreActions'].includes([
        'addressBook/addNumber',
        'addressBook/getList']);
    },
  },

  methods: {
    deleteCharacters(val) {
      if (!(/^\d+$/.test(val))) {
        this.addressBookNewItemForm.num_a = val.slice(0,-1);
      }
    },
    cancelForm() {
      this.$refs.addressBookNewItemForm.resetFields();
      this.$emit('closeModal');
    },
    submitForm() {
      this.$refs.addressBookNewItemForm.validate(async (valid) => {
        if (valid) {
          await this.$store.dispatch('addressBook/addNumber', this.addressBookNewItemForm);
          this.$message({
            type: 'success',
            message: `Numer ${this.addressBookNewItemForm.num_a} został dopisany do książki adresowej`,
          });

          this.$emit('refreshList');
          this.$emit('closeModal');
        }
      });
    },
  },

};
